import cloneDeep from 'lodash/cloneDeep';
import pick from 'lodash/pick';

import type { ConfigType } from '@plone/registry';

export const COLUMN_GRID_ALLOWED_BLOCKS = [
  'csjCard',
  'slate',
  'csjIconCardGrid',
  'image',
] as const;

export const ICON_CARD_GRID_ALLOWED_BLOCKS = ['csjCard'] as const;

export const TAB_ALLOWED_BLOCKS = ['slate', 'csjColumnGrid', 'image'] as const;

export const pickNestedBlocksConfig = (
  blocksConfig: ConfigType['blocks']['blocksConfig'],
  allowedBlocks: readonly string[],
) => cloneDeep(pick(blocksConfig, allowedBlocks));
